"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDataTableComponent = _interopRequireDefault(require("react-data-table-component"));
var _useChartData = require("../hooks/useChartData");
var _labelFormatter = require("../utils/label-formatter");
var _useColor = require("../hooks/useColor");
var _constants = require("../constants");
var _chartOperations = require("../utils/chart-operations");
var _useFilter = require("../hooks/useFilter");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const TableChart = /*#__PURE__*/(0, _react.memo)(chartProps => {
  const {
    chart,
    geography,
    chartColors,
    layout
  } = chartProps;
  const colorConfig = chart.colors || chartColors;
  if (colorConfig && !colorConfig.settings) {
    colorConfig.settings = {
      direction: "ascending",
      divergingMidPoint: 0,
      steps: 6
    };
  }
  const {
    xCol,
    yCol,
    yFormat,
    seriesCol
  } = chart;
  const {
    seriesColumnName,
    rowsPerPage = 10,
    heatmap = "none",
    highlightMain = false,
    sortColumnIndex = 1,
    sortAscending = true,
    pdfMaxRows = null
  } = chart.componentProps;
  const {
    filter,
    filterComponent
  } = (0, _useFilter.useFilter)(chartProps);
  const {
    data,
    xLabels,
    seriesKeys
  } = (0, _useChartData.useChartData)(chart, filter);
  const {
    calculateColorStops,
    getContrastColor
  } = (0, _useColor.useColor)(colorConfig, heatmap);
  let tableData = data.map(d => {
    var _chart$dataView$colum;
    return {
      _series: ((_chart$dataView$colum = chart.dataView.columns[seriesCol].categories[d.seriesKey]) === null || _chart$dataView$colum === void 0 ? void 0 : _chart$dataView$colum.label) || (seriesCol === _constants.COL_DATE ? (0, _chartOperations.formatDate)(d.seriesKey) : d.seriesKey),
      _rel: seriesCol === _constants.COL_GEO_ID && d.seriesKey === geography.id ? "main" : "",
      ...d.points.reduce((prev, p) => {
        return {
          ...prev,
          [p[xCol]]: p[yCol]
        };
      }, {})
    };
  });
  let colorStops = [];
  if (heatmap !== "none") {
    const values = tableData.map(row => Object.values({
      ...row,
      _series: undefined
    }).map(v => Number(v)).filter(n => !isNaN(n))).flat();
    colorStops = calculateColorStops(values, false);
    colorStops.push([Infinity, colorStops.at(-1)[1]]);
  } else {
    colorStops.push([Infinity, "#ffffff"]);
  }
  const columns = [{
    name: seriesColumnName || seriesCol,
    selector: row => row._series,
    grow: 1,
    sortable: true,
    sortFunction: (row1, row2) => {
      return seriesKeys.findIndex(key => key == row1._series) - seriesKeys.findIndex(key => key == row1._series);
    },
    wrap: true,
    conditionalCellStyles: [{
      when: row => highlightMain && row._rel === "main",
      style: {
        fontWeight: "bold"
      }
    }]
  }, ...xLabels.map(label => ({
    name: label.label,
    selector: row => row[label.key],
    sortable: true,
    format: row => isNaN(Number(row[label.key])) ? "N/A" : _labelFormatter.QuantitativeFormatter[yFormat](row[label.key]),
    minWidth: "80px",
    grow: 0.65,
    sortFunction: (row1, row2) => {
      if (!isNaN(Number(row1[label.key]))) {
        return Number(row1[label.key]) - Number(row2[label.key]);
      } else {
        var _row1$label$key;
        return (_row1$label$key = row1[label.key]) === null || _row1$label$key === void 0 ? void 0 : _row1$label$key.localeCompare(row2[label.key]);
      }
    },
    conditionalCellStyles: colorStops.map(stop => ({
      when: row => Number(row[label.key]) <= stop[0],
      style: row => ({
        backgroundColor: stop[1],
        color: getContrastColor(stop[1]),
        fontWeight: highlightMain && (row._rel === "main" || xCol === _constants.COL_GEO_ID && label.key === geography.id) ? "bold" : "normal"
      })
    })).reverse()
  }))];
  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold"
      }
    },
    headRow: {
      style: {
        backgroundColor: "#f6f6f6"
      }
    },
    tableWrapper: {
      style: {
        marginTop: "1.5rem",
        marginBottom: "1rem",
        pageBreakInside: "avoid"
      }
    }
  };
  if (layout === "print") {
    const sliceSize = 16;
    const dataSlices = [];
    if (pdfMaxRows) {
      tableData = tableData.slice(0, pdfMaxRows);
    }
    for (let i = 0; i < Math.ceil(tableData.length / sliceSize); i++) {
      dataSlices.push(tableData.slice(i * sliceSize, (i + 1) * sliceSize));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, dataSlices.map((sliceData, idx) => /*#__PURE__*/_react.default.createElement(_reactDataTableComponent.default, {
      key: idx,
      columns: columns,
      data: sliceData,
      customStyles: customStyles,
      dense: true,
      defaultSortFieldId: sortColumnIndex
    })));
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: "1rem"
      }
    }, filterComponent), /*#__PURE__*/_react.default.createElement(_reactDataTableComponent.default, {
      columns: columns,
      data: tableData,
      paginationComponentOptions: {
        noRowsPerPage: true
      },
      pagination: tableData.length > rowsPerPage,
      paginationPerPage: rowsPerPage,
      customStyles: customStyles,
      dense: true,
      defaultSortFieldId: sortColumnIndex,
      defaultSortAsc: sortAscending
    }));
  }
});
var _default = TableChart;
exports.default = _default;